class AriaComboboxTrigger extends HTMLElement {
  constructor() {
    super();

    this.handleButtonClick = (e) => {
      const targetPopupId = this.dataset.controls;
      this.button.dispatchEvent(
        new CustomEvent("aria-combobox:toggle", {
          bubbles: true,
          detail: { id: targetPopupId },
        }),
      );
    };
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.button.addEventListener("click", this.handleButtonClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.handleButtonClick);
  }
}

if (!customElements.get("aria-combobox-trigger")) {
  customElements.define("aria-combobox-trigger", AriaComboboxTrigger);
}
